import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const Card = styled(Box)`
    width: 140px;
    height: 43px;
    background: ${({ theme }) => theme.colors.grewSecond};
    cursor: pointer;
`
export const Link = styled.a`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const ImageIcon = styled.img`
    width: 14px;
    height: 14px;
    margin-right: 12px;
    fill: #0000;
`
export const ContentTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 12px;
    color: ${({ theme }) => theme.colors.white};
`
